import { render, staticRenderFns } from "./QuizChoiceForm.vue?vue&type=template&id=dc27608c&scoped=true&"
import script from "./QuizChoiceForm.vue?vue&type=script&lang=ts&"
export * from "./QuizChoiceForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuizChoiceForm.vue?vue&type=style&index=0&id=dc27608c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc27608c",
  null
  
)

export default component.exports